module.exports = __webpack_public_path__ + "img/1586112363.31da085e.jpg";